var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCalculation = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 8.062a8.001 8.001 0 1 0 5.65 14.45l-5.385-5.834A1 1 0 0 1 15 16V8.062Zm2 0V15h6.938A8.004 8.004 0 0 0 17 8.062ZM23.938 17h-5.654l3.835 4.154A7.965 7.965 0 0 0 23.939 17ZM6 16c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10S6 21.523 6 16Z"
})));
export default SvgCalculation;